import { HttpClient } from './types';


export const createProductService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/productos${url}`;

  return {
    getProductById: <TProduct = any>(productId: string): Promise<TProduct> => {
      return httpClient.get<TProduct>(getEndpoint(`/${productId}`));
    },

    getProductBySku: <TProduct = any>(productSku: string): Promise<TProduct> => {
      return httpClient.get<TProduct>(getEndpoint(`/sku/${productSku}`));
    },

    getAllProducts: <TFilter = any, TResponse = any>(filter: TFilter, searchTerm?: string): Promise<TResponse> => {
      const params: any = { ...filter };
      if (searchTerm) {
        params.searchTerm = searchTerm;
      }
      
      if (httpClient.getWithQueryParamsSerializer) {
        return httpClient.getWithQueryParamsSerializer<TResponse>(getEndpoint(''), params);
      }
      
      return httpClient.get<TResponse>(getEndpoint(''), { params });
    },

    getLatest: <TProduct = any>(): Promise<TProduct[]> => {
      return httpClient.get<TProduct[]>(getEndpoint('/ultimos'));
    },

    getFeatured: <TProduct = any>(): Promise<TProduct[]> => {
      return httpClient.get<TProduct[]>(getEndpoint('/destacados'));
    },
    
    getHeroHome: <TProduct = any>(): Promise<TProduct[]> => {
      return httpClient.get<TProduct[]>(getEndpoint('/hero-home'));
    },

    getProductVariantAttributesWithValues: <TAttributes = any>(productId: string): Promise<TAttributes[]> => {
      return httpClient.get<TAttributes[]>(getEndpoint(`/${productId}/variantesAtributos`));
    },

    getProductVariantsByProductId: <TVariantDetail = any>(productId: string): Promise<TVariantDetail[]> => {
      return httpClient.get<TVariantDetail[]>(getEndpoint(`/${productId}/variantes`));
    },

    getProductVariantByAttributesValues: <TRequest = any, TVariant = any>(
      productId: string, 
      requestBody: TRequest
    ): Promise<TVariant[]> => {
      return httpClient.post<TVariant[]>(getEndpoint(`/${productId}/variante`), requestBody);
    },

    getProductVariantDetail: <TDetail = any>(productVariantId: string): Promise<TDetail> => {
      return httpClient.get<TDetail>(getEndpoint(`/variantes/${productVariantId}`));
    },
  };
};

